import { Injectable } from '@angular/core';
import { CONFLICT_MODAL_DESICION, CONFLICT_MODAL_STATE } from './reservations-conflict-modal.interfaces';

@Injectable()
export class DiningReservationsConflictModalService {

    reservationData: any;
    flowState: CONFLICT_MODAL_STATE;
    userSelection: CONFLICT_MODAL_DESICION;

    constructor() { }

    setUp(reservationData: any) {
        this.reservationData = reservationData;
        this.flowState = this.reservationData.cancelEligible ? CONFLICT_MODAL_STATE.DEFAULT : CONFLICT_MODAL_STATE.CONFLICT_NOT_CANCELABLE;
        this.userSelection = CONFLICT_MODAL_DESICION.DEFAULT;
    }

    keepReservation() {
        this.flowState = CONFLICT_MODAL_STATE.KEEP;
        this.userSelection = CONFLICT_MODAL_DESICION.KEEP;
    }

    cancelReservation() {
        this.flowState = CONFLICT_MODAL_STATE.CANCEL;
    }

    confirmCancel() {
        this.userSelection = CONFLICT_MODAL_DESICION.CANCEL;
    }

    back() {
        this.flowState = CONFLICT_MODAL_STATE.DEFAULT;
        this.userSelection = CONFLICT_MODAL_DESICION.DEFAULT;
    }

    isReservationCancelled() {
        return this.userSelection === CONFLICT_MODAL_DESICION.CANCEL;
    }
}
